"use client";
import { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";

// Renders the Cal.com "Book my Cal" floating button on every page. Mounted once
// from the root layout so it's available site-wide (previously it was only set
// up in the home hero via Book.jsx). Cal's floatingButton is a global singleton,
// so this must be the only place that registers it.
export default function CalFloatingButton() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal("floatingButton", {
        calLink: "getbiz.solutions/30min",
      });
      cal("ui", {
        styles: {
          branding: { brandColor: "#000000" },
        },
      });
    })();
  }, []);

  return null;
}
